// extracted by mini-css-extract-plugin
export var container = "uber-module--container--6WPm7";
export var back = "uber-module--back--R4+zj";
export var textWrap = "uber-module--textWrap--LIQ7P";
export var headerWrap = "uber-module--headerWrap--jF9FF";
export var header = "uber-module--header--W2UK2";
export var red = "uber-module--red--TnhJn";
export var text = "uber-module--text--t6Q5V";
export var notes = "uber-module--notes--PAdLi";